function resetBookingPersonsInput() {
  const bookingPersonsInput = document.querySelector("#yith-wcbk-booking-persons");

  if (!bookingPersonsInput) {
    return;
  }

  bookingPersonsInput.value = "";
  bookingPersonsInput.setAttribute("value", "");
}

export { resetBookingPersonsInput };
